import AppReducer from "@/Redux/App/AppReducer";
import DispositionReducer from "@/Redux/Disposition/DispositionReducer";
import UserReducer from "@/Redux/User/UserReducer";
import BookingReducer from "@/Redux/Booking/BookingReducer";
import SystemReducer from "@/Redux/System/SystemReducer";
import AuthReducer from "@/Redux/Auth/AuthReducer";
import QueryReducer from "@/Redux/Query/QueryReducer";
import RateReducer from "@/Redux/Rate/RateReducer";

const reducers = {
    app: AppReducer,
    user: UserReducer,
    booking: BookingReducer,
    auth: AuthReducer,
    system: SystemReducer,
    disposition: DispositionReducer,
    query: QueryReducer,
    rate: RateReducer,
};

export default reducers;
